import { useLangChecker } from '@common/utils/i18n';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
const ManalBreadcrumbs = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    const { breadcrumbs, shelf } = useSelector((state) => state.search);
    if (((_a = props.components) === null || _a === void 0 ? void 0 : _a.length) <= 1) {
        return React.createElement("div", null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("nav", { "aria-label": t('navigation.breadcrumb.aria'), className: "breadcrumb" },
            React.createElement("ol", null, (_b = props === null || props === void 0 ? void 0 : props.components) === null || _b === void 0 ? void 0 : _b.map((item, i) => (React.createElement("li", { key: i }, i + 1 !== props.components.length ? (React.createElement("a", { href: `${item.url}`, className: "breadcrumb__item", ref: useLangChecker }, item.label)) : (React.createElement("div", { "aria-current": "page", className: "breadcrumb__item" }, item.label)))))))));
};
export default ManalBreadcrumbs;
